exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".new_button {\n  background-color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 40px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: #303030;\n  border-radius: 4px;\n  cursor: pointer;\n  color: black;\n  text-decoration: none; }\n  .new_button:hover {\n    color: black;\n    text-decoration: none; }\n\n.new_customer_reservation_button {\n  background-color: black;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 315px;\n  height: 40px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: #303030;\n  border-radius: 4px;\n  cursor: pointer;\n  color: white;\n  text-decoration: none; }\n  .new_customer_reservation_button:hover {\n    color: white;\n    text-decoration: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/new_button.sass
// module id = 1374
// module chunks = 0